(function () {
  'use strict';

  var enabled = false;
  var gorgiasObserver = null;
  var GORGIAS_SELECTORS = [
    '#gorgias-web-messenger-container',
    '.gorgias-chat-container',
    '#gorgias-chat-container',
    'iframe[src*="gorgias"]',
    'iframe[title*="Gorgias"]',
  ].join(',');

  function enableGorgiasChat() {
    if (enabled) return;
    enabled = true;
    if (gorgiasObserver) {
      gorgiasObserver.disconnect();
      gorgiasObserver = null;
    }
    document.documentElement.classList.add('gorgias-chat-enabled');
    document.dispatchEvent(new CustomEvent('gorgias:enable'));
  }

  function hideGorgiasNode(node) {
    if (!node || enabled) return;
    if (node.nodeType !== 1) return;
    if (node.matches && node.matches(GORGIAS_SELECTORS)) {
      node.setAttribute('data-gorgias-deferred-hidden', 'true');
    }
    if (node.querySelectorAll) {
      node.querySelectorAll(GORGIAS_SELECTORS).forEach(function (el) {
        el.setAttribute('data-gorgias-deferred-hidden', 'true');
      });
    }
  }

  function bindChatTriggers() {
    document.querySelectorAll('#GorgiasChatLink, [data-gorgias-chat-trigger]').forEach(function (chatLink) {
      if (chatLink.dataset.gorgiasDeferredBound === 'true') return;
      chatLink.dataset.gorgiasDeferredBound = 'true';
      chatLink.addEventListener('click', function () {
        enableGorgiasChat();
      }, { capture: true });
    });
  }

  function openGorgiasChat() {
    enableGorgiasChat();
    if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
      window.GorgiasChat.open();
      return true;
    }
    return false;
  }

  function waitForGorgiasChat(callback, attempts) {
    var remaining = typeof attempts === 'number' ? attempts : 40;
    if (openGorgiasChat()) {
      callback(true);
      return;
    }
    if (remaining <= 0) {
      callback(false);
      return;
    }
    window.setTimeout(function () {
      waitForGorgiasChat(callback, remaining - 1);
    }, 250);
  }

  window.enableGorgiasChat = enableGorgiasChat;
  window.openGorgiasChatDeferred = function (callback) {
    waitForGorgiasChat(callback || function () {}, 40);
  };

  function onScroll() {
    if (window.scrollY > 300) {
      enableGorgiasChat();
      window.removeEventListener('scroll', onScroll);
    }
  }

  if ('MutationObserver' in window) {
    gorgiasObserver = new MutationObserver(function (mutations) {
      if (enabled) return;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(hideGorgiasNode);
      });
    });
    gorgiasObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  bindChatTriggers();
  document.addEventListener('DOMContentLoaded', bindChatTriggers);
  window.addEventListener('scroll', onScroll, { passive: true });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(enableGorgiasChat, { timeout: 12000 });
  } else {
    window.addEventListener('load', function () {
      window.setTimeout(enableGorgiasChat, 12000);
    }, { once: true });
  }
})();
